import React from 'react'
import { graphql, useStaticQuery} from 'gatsby'
import UserInfo from './UserInfo'

const queryWrapper = ({ expanded, author, postNode }) => {
  const data = useStaticQuery(graphql`
    query UserImageQuery {
      allFile(filter: { relativeDirectory: { eq: "images/team" } }) {
        edges {
          node {
            relativePath
            absolutePath
            childImageSharp {
              gatsbyImageData(width: 160)
            }
          }
        }
      }
    }
  `)
  return (
    <UserInfo
      expanded={expanded}
      userImages={data.allFile.edges}
      author={author}
      postNode={postNode}
    />
  )
}

export default queryWrapper
